<mat-form-field class="grow">
    <app-select-search
        [placeholder]="TravelZoneEntity.EntityName"
        [ngModel]="value$ | async"
        (ngModelChange)="valueChanged($event)"
        [Options]="options$ | async"
        [OptionTemplate]="optionTemplate"
        [CompareOptions]="compareById"

    ></app-select-search>

<!--    [formControl]="_formControl"-->
</mat-form-field>
<button app-round-button (click)="onAddClick()"><fa-icon icon="plus"></fa-icon></button>
<ng-template #optionTemplate let-option>
    <div class="flex items-centers gap-2">
        {{ option.Name }} {{ option.Description }} <fa-icon *ngIf="option.ArlTemplateId" [icon]="BookingPositionMetaIcon"></fa-icon>
        <button app-round-button matTooltip="Bearbeiten" matTooltipPosition="left" (click)="$event.stopPropagation(); onEditClick(option)" style="margin-left: auto;">
            <fa-icon icon="pencil-alt"></fa-icon>
        </button>
    </div>
 </ng-template>

